import * as React from "react";
import {
    CAROUSEL_BANNERS,
    CommonHelpers,
    MTA_EDIT_VEHICLE_DETAILS_PATH,
    resourcesHelper
} from "@falcon/services";
import {Link} from "react-router-dom";
import {pushClickEvent} from "./carouselEvents";

interface IProps {
    interaction_id: string;
}

export class BreakdownCarouselBanner extends React.Component<IProps> {

    public render() {
        return (
            <div className="banner carousel-banner banner-content">
                <img className="banner-icon" src={`/${resourcesHelper.THEME}/img/breakdown-cover.svg`} alt="Breakdown icon"/>
                <div className="banner-text">
                    <div className="banner-title mb-3">Breakdown cover</div>
                    Choose from our 3 levels of breakdown cover: Local, National or European.
                    <p className="mt-3">
                        <Link
                            className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                            onClick={() => this.onClick()}
                            to={this.navigateToEditCarBreakdownCover()}>
                            <img className="carousel-banner-arrow"
                                 src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}
                                 alt="Arrow icon"
                            />Add Breakdown to your policy
                        </Link>
                    </p>
                </div>
            </div>
        )
    }

    private onClick() {
        pushClickEvent(
            CAROUSEL_BANNERS.breakdown.name,
            MTA_EDIT_VEHICLE_DETAILS_PATH + this.props.interaction_id,
            CAROUSEL_BANNERS.breakdown.id
        );
        CommonHelpers.setSessionStorage("scrollToBreakdownCover", true);
    }

    private navigateToEditCarBreakdownCover() {
        return `${MTA_EDIT_VEHICLE_DETAILS_PATH}${this.props.interaction_id}`;
    }
}
